module.exports = __webpack_public_path__ + "img/key_features--mobilization.aba1a5d7.jpg";